import * as React from 'react';
import './ParentInvite.scss';
import { Link } from 'react-router-dom';
import { History, Location } from 'history';
import { getFromHistory } from '../../../helpers/history';
import { useEffect, useState } from 'react';
import { SimpleModal } from '../../../components/SimpleModal/SimpleModal';
import { Loader } from '../../../components/Loader/Loader';
import { getParentInviteByCode } from '../../../services/public/prereg';

interface Props {
  history: History;
  location: Location;
  isAuthorizedCustomer: boolean;
  match: { params: { parentInviteCode?: string } };
}

export function ParentInvite(props: Props) {
  const { history, isAuthorizedCustomer } = props;

  const [resolvedSchoolCode, setResolvedSchoolCode] = useState<string | undefined>(undefined);
  const [isResolvingCode, setIsResolvingCode] = useState(Boolean(props.match.params.parentInviteCode));
  const [resolveError, setResolveError] = useState('');
  const parentInviteCode = props.match.params.parentInviteCode;

  useEffect(() => {
    if (!parentInviteCode) return;
    getParentInviteByCode(parentInviteCode)
      .then(result => {
        setResolvedSchoolCode(result.schoolCode);
        setIsResolvingCode(false);
      })
      .catch(() => {
        setResolveError('This parent invitation link is not valid. Please contact your school for a new link.');
        setIsResolvingCode(false);
      });
  }, [parentInviteCode]);

  const schoolCode = resolvedSchoolCode || getFromHistory(history, 'schoolCode');
  const isSchoolCodeValid = !!schoolCode && schoolCode !== 'undefined';

  const searchParams = new URLSearchParams();
  if (isSchoolCodeValid) {
    searchParams.append('schoolCode', schoolCode as string);
  } else {
    searchParams.append('isParentInvite', 'true');
  }

  let existingCustomerPathname;
  if (isAuthorizedCustomer) {
    existingCustomerPathname = `/customer/profile?${searchParams.toString()}`;
  } else {
    existingCustomerPathname = `/login?${searchParams.toString()}`;
  }

  const [isParentInviteInfoFormModalOpen, setIsParentInviteInfoFormModalOpen] = useState(false);
  const onParentInviteInfoFormModalOpen = (): void => {
    setIsParentInviteInfoFormModalOpen(true);
  };
  const onParentInviteInfoFormModalClose = (): void => {
    setIsParentInviteInfoFormModalOpen(false);
  };

  const renderInfoModal = () => {
    const infoText =
      'We are delighted to bring you our new Quick Pics service.\n' +
      '\n' +
      "Quick Pics will allow us to supply you with a bespoke service ensuring that you never miss your child's school photographs.\n" +
      '\n' +
      'We are able to link any new images to your account during the school academic year simply by you registering your child(s) details.\n' +
      '\n' +
      'We promise we will NEVER pass your information to any third party.';

    return (
      <SimpleModal
        isOpen={isParentInviteInfoFormModalOpen}
        title={''}
        body={infoText}
        buttonCancelText={'Ok'}
        onCloseClick={onParentInviteInfoFormModalClose}
      />
    );
  };

  const classes = isParentInviteInfoFormModalOpen ? 'mt-3 modal-open' : 'mt-3';

  if (isResolvingCode) return <Loader />;
  if (resolveError) {
    return (
      <SimpleModal
        isOpen={true}
        title={'Parent invitation'}
        body={resolveError}
        buttonCancelText={'Ok'}
        onCloseClick={() => history.push('/')}
      />
    );
  }

  return (
    <div className={classes}>
      {renderInfoModal()}
      <div className="container">
        <div className="row">
          <div className={'col-xl-12'}>
            <div className={'eParentInviteTitle'}>Quick Pics</div>
          </div>
          <div className="mb-4 w-100 text-center">
            <a className="eParentInviteLinkText" onClick={onParentInviteInfoFormModalOpen}>
              What's this?
            </a>
          </div>
          <div className="progress-line mt-2">
            <div className="circle filled"></div>
            <div className="line"></div>
            <div className="circle empty"></div>
            <div className="line"></div>
            <div className="circle empty"></div>
          </div>
        </div>
        <div className="row">
          {/* Left Column for Text */}
          <div className="col-xl-8 text-left">
            <p className="eParentInviteText">
              For security of your childrens images we require you to either create an account or log into your existing
              account.
            </p>
          </div>
          {/* Right Column for Buttons */}
          <div className="col-xl-4 d-flex flex-column align-items-center">
            <div className={'eParentInviteLink mColorBlue mb-3'}>
              <Link to={{ pathname: '/registration', search: searchParams.toString() }}>New customer</Link>
            </div>
            <div className={'eParentInviteLink mColorRed'}>
              <Link to={existingCustomerPathname}>Existing customer</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
